import { Box, styled, Typography, alpha } from '@mui/material';
import React from 'react';
import { Slide } from '../ReportComponents';
import blitzLogo from '../../../Components/globalAssets/platty.png';

/** 
 * 1. SparkleOverlay:
 * - Subtle sparkle background, less harsh, using alpha() for partial transparency
 * - Added a "fade-in" animation 
 */
const SparkleOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  inset: 0,
  pointerEvents: 'none',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(4),
  animation: 'fadeIn 1.2s ease-in forwards',

  background: `
    radial-gradient(${alpha(theme.palette.primary.light, 0.15)} 2px, transparent 2px),
    radial-gradient(${alpha(theme.palette.primary.light, 0.15)} 2px, transparent 2px)
  `,
  backgroundSize: '40px 40px',
  backgroundPosition: '0 0, 20px 20px',

  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
}));

/**
 * 2. Logo:
 * - Maintained a circular or square ratio but with a sleek boxShadow
 * - Subtle transition on hover
 */
const Logo = styled('img')(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  width: '12.5vh',
  height: '12.5vh',
  objectFit: 'contain',
  boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, 0.2)}`,
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'scale(1.05)',
  },
}));

export default function OpeningSlide({ index, currentSlide, report }) {
  return (
    <Slide
      id="slide-intro"
      index={index}
      currentIndex={currentSlide}
      sx={{
        background: `linear-gradient(180deg, 
          ${alpha('#7B2A2A', 0.9)}, 
          ${alpha('#191414', 0.95)})`,
      }}
    >
      <SparkleOverlay>
        <Box
          id="logos-container"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            maxWidth: 360,
            mb: 3,
          }}
        >
          <Logo src={blitzLogo} alt="Logo" />
          <Typography
            variant="h1"
            sx={{
              color: 'white',
              fontSize: 'clamp(1.8rem, 4vw, 3rem)',
              fontWeight: 800,
              textAlign: 'center',
            }}
          >
            X
          </Typography>
          <Logo src={report?.pfp} alt="Logo" />
        </Box>
        <Typography
          variant="h3"
          sx={{
            color: '#fff',
            fontSize: 'clamp(1.5rem, 5vw, 2.2rem)',
            fontWeight: 700,
            mb: 1,
          }}
        >
          Your Campaign Recap
        </Typography>
        <Typography
          variant="h4"
          color="text.secondary"
          sx={{
            fontSize: 'clamp(1rem, 4vw, 1.5rem)',
            mb: 1,
          }}
        >
          {report?.name}
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Results Report
        </Typography>
      </SparkleOverlay>
    </Slide>
  );
}
